'use strict';

import { environment } from '@quartz-gov-legacy/environments/environment';

angular.module('riskModule')

.factory('grcRiskService', ['$http', '$q', function ($http, $q) {
    var baseUrl = environment.apiUrl + '/Pilot/api/Risk';

    var service = {};

    // Risk
    service.getRisk = function (riskId) {
        return $http
            .get(baseUrl + '/' + riskId)
            .then(function (response) { return response.data; });
    };
    service.createOrUpdateRisk = function (risk) {
        var reqUrl = baseUrl;
        if (!_.isUndefined(risk.RiskID)) reqUrl += '/' + risk.RiskID;

        return $http
            .post(reqUrl, { Risk: risk })
            .then(function (response) { return response.data; });
    };
    service.closeRisk = function (risk) {
        return $http
            .post(baseUrl + '/' + risk.RiskID + '/Close', { Risk: risk })
            .then(function (response) { return response.data; });
    };
    service.getHistoricOnRisk = function (riskId) {
        return $http
            .get(baseUrl + '/' + riskId + '/Historic')
            .then(function (response) { return response.data; });
    };

    // Search Risks
    service.searchDepartmentRisks = function (searchTerm) {
        return $http
            .get(baseUrl + '/Department/Search/' + searchTerm)
            .then(function (response) { return response.data; });
    };

    // Add Control To Risk
    service.addControlToRisk = function (riskId, controlId) {
        return $http
            .post(baseUrl + '/' + riskId + '/Control/' + controlId)
            .then(function (response) { return response.data; });
    };
    service.removeControlFromRisk = function (riskId, controlId) {
        return $http
            .delete(baseUrl + '/' + riskId + '/Control/' + controlId)
            .then(function (response) { return response.data; });
    };

    // Risk Assessment
    service.getRiskAssessments = function (riskId) {
        return $http
            .get(baseUrl + '/' + riskId + '/Assessment')
            .then(function (response) { return response.data; });
    };

    // Sub Risks
    service.getSubRisks = function (riskId) {
        return $http
            .get(baseUrl + '/' + riskId + '/SubRisk')
            .then(function (response) { return response.data; });
    };

    // Related Controls
    service.getRelatedControls = function (riskId) {
        return $http
            .get(baseUrl + '/' + riskId + '/Control')
            .then(function (response) { return response.data; });
    };

    // Related Risk Events
    service.getRelatedRiskEvents = function (riskId) {
        return $http
            .get(baseUrl + '/' + riskId + '/RiskEvent')
            .then(function (response) { return response.data; });
    };

    // RiskType
    service.getAllRiskTypes = function () {
        return $http
            .get(environment.apiUrl + '/Pilot/api/RiskType')
            .then(function (response) { return response.data; });
    };

    // RiskLevel
    service.getAllRiskLevels = function () {
        return $http
            .get(environment.apiUrl + '/Pilot/api/RiskLevel')
            .then(function (response) { return response.data; });
    };

    // Risks
    service.getAllActiveRisks = function (opts) {
        return $http
            .get(baseUrl + '/Active', opts)
            .then(function (response) { return response.data; });
    };

    return service;
}]);
